import useCompany from './useCompany';

const useStreamType = () => {
  const { company } = useCompany();
  return company?.streamType || null;
};

export default useStreamType;
